<div class="fc-jod-page">

  <!-- Toolbar -->
  <div class="fc-jod-toolbar">
    <button class="fc-btn fc-btn--ghost" (click)="onBackClicked()" mat-button>
      <mat-icon>arrow_back</mat-icon> Back
    </button>
    <div class="fc-jod-actions">
      <button class="fc-btn fc-btn--outline" (click)="onCsvDownloadClicked()" mat-button>
        <mat-icon>download</mat-icon> JobOrder CSV
      </button>
      <button class="fc-btn fc-btn--outline" (click)="onDataStatesCsvDownloadClicked()" mat-button>
        <mat-icon>download</mat-icon> Data States CSV
      </button>
    </div>
  </div>

  <!-- Layout -->
  <div class="fc-jod-layout">

    <!-- Left column -->
    <div class="fc-jod-main">

      <!-- Job Detail -->
      <div class="fc-card">
        <div class="fc-card-header">
          <h3 class="fc-card-title">Job Detail</h3>
        </div>
        <div class="fc-fields-grid">
          <div class="fc-field">
            <span class="fc-field-label">Name</span>
            <span class="fc-field-value">{{ jobOrderDetail?.code }}</span>
          </div>
          <div class="fc-field" *ngIf="jobOrderDetail?.description">
            <span class="fc-field-label">Description</span>
            <span class="fc-field-value">{{ jobOrderDetail?.description }}</span>
          </div>
          <div class="fc-field" *ngIf="jobOrderDetail?.difficulty">
            <span class="fc-field-label">Difficulty</span>
            <span class="fc-field-value">{{ jobOrderDetail?.difficulty }}</span>
          </div>
          <div class="fc-field fc-field--full" *ngIf="jobOrderDetail?.note">
            <span class="fc-field-label">Notes</span>
            <span class="fc-field-value">{{ jobOrderDetail?.note }}</span>
          </div>
        </div>
      </div>

      <!-- Timings -->
      <div class="fc-card">
        <div class="fc-card-header">
          <h3 class="fc-card-title">Timings</h3>
        </div>
        <div class="fc-fields-grid">
          <div class="fc-field">
            <span class="fc-field-label">Start</span>
            <span class="fc-field-value fc-mono">{{ jobOrderDetail?.startDate | date: "medium" }}</span>
          </div>
          <div class="fc-field">
            <span class="fc-field-label">End</span>
            <span class="fc-field-value fc-mono">{{ jobOrderDetail?.endDate | date: "medium" || "--" }}</span>
          </div>
          <div class="fc-field">
            <span class="fc-field-label">Total Time</span>
            <span class="fc-field-value fc-mono">{{ jobOrderDetail?.totalTimeAsHHmmss }}</span>
          </div>
          <div class="fc-field">
            <span class="fc-field-label">Effective Time</span>
            <span class="fc-field-value fc-mono fc-field-value--success">{{ jobOrderDetail?.effectiveWorkingTimeAsHHmmss }}</span>
          </div>
          <div class="fc-field">
            <span class="fc-field-label">Loss Time</span>
            <span class="fc-field-value fc-mono fc-field-value--danger">{{ jobOrderDetail?.totalLostTimeAsHHmmss }}</span>
          </div>
        </div>

        <div class="fc-chart-section" *ngIf="chartData">
          <google-chart [data]="chartData"></google-chart>
        </div>
        <div class="fc-chart-section" *ngIf="histogramData">
          <div class="fc-chart-header">
            <mat-slide-toggle (change)="wastedToggleHandler()">Wasted</mat-slide-toggle>
          </div>
          <google-chart #histogram [data]="histogramData"></google-chart>
        </div>
      </div>

    </div>

    <!-- Right column -->
    <div class="fc-jod-sidebar">

      <!-- Delivery -->
      <div class="fc-card" *ngIf="deliveryDate">
        <div class="fc-card-header">
          <h3 class="fc-card-title">Delivery</h3>
        </div>
        <div class="fc-calendar-wrap">
          <mat-calendar #calendar [startAt]="deliveryDate" [selected]="deliveryDate"></mat-calendar>
        </div>
      </div>

      <!-- Customer -->
      <div class="fc-card">
        <div class="fc-card-header">
          <h3 class="fc-card-title">Customer</h3>
        </div>
        <div class="fc-customer-row">
          <span class="material-icons fc-customer-icon">badge</span>
          <span class="fc-customer-name">{{ jobOrderDetail?.finalCustomer }}</span>
        </div>
      </div>

      <!-- Data States -->
      <div
        class="fc-card"
        *ngIf="jobOrderDetail != undefined && jobOrderDetail.relatedDataStates.length > 0"
      >
        <div class="fc-card-header">
          <h3 class="fc-card-title">Data states</h3>
          <span class="fc-card-count">{{ jobOrderDetail.relatedDataStates.length }}</span>
        </div>
        <div class="fc-states-list">
          <div class="fc-state-item" *ngFor="let state of jobOrderDetail?.relatedDataStates">
            <div class="fc-state-top">
              <span class="fc-state-machine">{{ state.machineName }}</span>
              <span class="fc-state-ts">{{ state.dateTimeState }}</span>
            </div>
            <div class="fc-state-desc">{{ state.description }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
